module.exports = __webpack_public_path__ + "fd94926e7164a8dd4bf55bfd11eda0a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/lightbulb-off.png
// module id = 1641
// module chunks = 0